import gql from 'graphql-tag'

export const EDIT_ATTRACTION = gql
`
mutation update_attractions_by_pk(
  $id: uuid!
  $description: String
  $name: String
  $open_hours: String
  $image_url: String
  $image_path: String
  $location: geometry
  $location_text: String
  $same_open_hours: Boolean
  $type_of_attraction: String
) {
  update_attractions_by_pk(
    pk_columns: { id: $id }
    _set: {
      name: $name
      open_hours: $open_hours
      type_of_attraction: $type_of_attraction
      description: $description
      image_url: $image_url
      image_path: $image_path
      location: $location
      location_text: $location_text
      same_open_hours: $same_open_hours
    }
  ) {
    id
  }
}

`

  